var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-aside',{attrs:{"width":"280px"}},[_c('Sidebar',{on:{"menuClick":_vm.menuClickHandle}})],1),_c('el-main',[_c('div',{staticClass:"userBook"},[_c(_vm.currentComponent,{tag:"component"})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }